import type {StatsigOptions, StatsigUser} from '@statsig/js-client';
import {StatsigClient} from '@statsig/js-client';

let statsigClient: StatsigClient | null = null;

export function createStatsigClient(
  sdkKey: string,
  user: StatsigUser,
  options?: StatsigOptions | null
) {
  statsigClient = new StatsigClient(sdkKey, user, options);
  return statsigClient;
}

export function statsigClientExists(): boolean {
  return Boolean(statsigClient);
}

export function getStatsigClient(): StatsigClient {
  if (!statsigClient) {
    throw new Error('statsigClient is null');
  }
  return statsigClient;
}

export function nullifyStatsigClientReference() {
  statsigClient = null;
}
